import {Box, DialogContent, Divider, Tab} from '@mui/material';
import {TabContext, TabList, TabPanel} from '@mui/lab';
import {useState} from 'react';
import ProfileForm from './ProfileForm';
import ReceiverForm from './ReceiverForm';
import {useFetch} from '../../../hooks/useFetch';
import AnfitriaoForm from './AnfitriaoForm';

export default ({user_id, close, mutate: listMutate}) => {
    const {data, error, mutate, isLoading} = useFetch(`/backoffice/users/${user_id}`);

    const refreshAll = () => {
        mutate();
        if (listMutate) listMutate();
    };
    const [value, setValue] = useState(1);

    if (isLoading) return null;

    return (
        <>
            
                <TabContext value={value}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList onChange={(e, newValue) => setValue(newValue)}>
                            <Tab label="Usuário" value={1} />
                            <Tab
                                disabled={!Boolean(data?.profile)}
                                label="Perfil de Anfitrião"
                                value={2}
                            />
                            <Tab
                                disabled={!Boolean(data?.profile)}
                                label="Dados do recebedor"
                                value={3}
                            />
                        </TabList>
                    </Box>
                    <TabPanel value={1} sx={{px: 0}}>
                        <ProfileForm data={data} mutate={refreshAll} />
                    </TabPanel>
                    <TabPanel value={2} sx={{px: 0}}>
                        <AnfitriaoForm data={data} mutate={refreshAll} close={close} />
                    </TabPanel>
                    <TabPanel value={3} sx={{px: 0}}>
                        {data?.profile && <ReceiverForm data={data} mutate={refreshAll} close={close} />}
                    </TabPanel>
                </TabContext>
              
        </>
    );
};
